export default
{
	availableUnits: 7,
	score: {
		min: 2,
		max: 6,
		displayMax: 7
	},
	patientState: 1,
	blindsState: 1,
	name: "delier0",
	day: 0,
	date: {
		time: "09:33",
		day: "scene.date.text"
	},
	delirium: {
		initialState: "oranje",
		clockPosition: {
			x: 780,
			y: 183
		},
		videoUrls: [
			{
				whiteboardState: 0,
				blindsState: 1,
				url: "delier0/${locale}/delier_0_nacht_ochtend_blinds-open.flv"
			}
		],
		roomViewToggleButtonPosition: {
			x: 1583,
			y: 386
		}
	},
	room: {
		backgroundImage: {
			blindsOpenUrl: "delier0/delier0_nurseview_room_blinds_open.jpg",
			blindsClosedUrl: "delier0/delier0_nurseview_room_blinds_closed.jpg"
		},
		clock: {
			blindsOpenUrl: "delier0/delier0_nurseview_room_blinds_open_klok.png",
			blindsClosedUrl: "delier0/delier0_nurseview_room_blinds_closed_klok.png"
		}
	},
	end: {
		clockPosition: {
			x: 783,
			y: 136
		},
		videoUrls: [
			{
				whiteboardState: 0,
				blindsState: 1,
				url: "delier0/${locale}/delier_0_slot_blinds_open.flv"
			},
			{
				whiteboardState: 1,
				blindsState: 1,
				url: "delier0/${locale}/delier_0_slot_blinds_open_ma.flv"
			}
		]
	},
	transitions: [
		{
			deliriumState: "wit",
			target: "delier1"
		},
		{
			deliriumState: "groen",
			target: "delier1"
		},
		{
			deliriumState: "oranje",
			target: "delier1"
		},
		{
			deliriumState: "rood",
			target: "delier1"
		}
	],
	mediaUrls: [
		{
			categoryName: "communiceren",
			value: "delier0/${locale}/delier_0_dialoog_start.flv"
		},
		{
			categoryName: "communiceren",
			actionName: "patientnegeren",
			value: "delier0/${locale}/delier_0_dialoog_negeren.flv"
		},
		{
			categoryName: "communiceren",
			actionName: "vragenovervoorgaandeoperatie",
			value: "delier0/${locale}/delier_0_dialoog_doorvrorientatie.flv"
		},
		{
			categoryName: "communiceren",
			actionName: "roomingin",
			value: "delier0/${locale}/delier_0_dialoog_partner.flv"
		},
		{
			categoryName: "communiceren",
			actionName: "afrondenenkamerverlaten",
			value: "delier0/${locale}/delier_0_dialoog_dag.flv"
		},
		{
			categoryName: "",
			actionName: "",
			value: ""
		}
	]
}